export default __webpack_public_path__ + "static/media/excel-upload.831ad105.svg";